export { default } from './FocusTrap';
export type { FocusTrapProps as TrapFocusProps } from './FocusTrap.types';
